import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asociaciones',
  templateUrl: './asociaciones.component.html',
  styleUrls: ['./asociaciones.component.scss']
})
export class AsociacionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
